/** KPI metric card for the Labour Management demo screen - shows a value, a small
 * comparison-to-target/previous-period line and a status-coloured left border/dot. */

import { Box, Typography, useTheme } from '@mui/material';
import { KpiCardData } from '../types';
import { statusToColor } from './StatusChip';

const STATUS_HEX: Record<KpiCardData['status'], string> = {
  good: '#12B76A',
  warning: '#F79009',
  critical: '#F04438',
};

interface KpiCardProps {
  data: KpiCardData;
}

const KpiCard = ({ data }: KpiCardProps) => {
  const theme = useTheme();
  return (
    <Box sx={{
      border: '1px solid',
      borderColor: theme.palette.custom.gray[300],
      borderLeft: '4px solid',
      borderLeftColor: STATUS_HEX[data.status],
      borderRadius: '10px',
      p: 3,
      height: '100%',
    }}>
      <Typography variant="textXS"
        color="text.secondary">
        {data.label}
      </Typography>
      <Typography variant="textLG"
        fontWeight={600}
        sx={{ mt: 0.5 }}>
        {data.value}
      </Typography>
      <Typography variant="textXS"
        color={`${statusToColor(data.status)}.main`}
        sx={{ mt: 0.5, display: 'block' }}>
        {data.comparisonLabel}
      </Typography>
    </Box>
  );
};

export default KpiCard;
